import { Root, Trigger } from '@radix-ui/react-dialog';
import { DialogContent as Content } from './components';

export const Dialog = Root;
export const DialogTrigger = Trigger;
export const DialogContent = Content;
